import { graphql, useMutation } from "react-relay";
import { useTodoEditAddImageImageMutation } from "./__generated__/useTodoEditAddImageImageMutation.graphql";
import { useUploadImage } from "arkh";
import { useCallback } from "react";
import { usePersistedEmployeeId } from "@/src/OS/Login/usePersistedEmployeeId";

export function useTodoEditAddImage(id: string) {
  const { currentEmployeeId } = usePersistedEmployeeId();
  const [addImageMutation] = useMutation<useTodoEditAddImageImageMutation>(
    graphql`
      mutation useTodoEditAddImageImageMutation($todoId: ID!, $employeeId: ID) {
        todo(todoId: $todoId, employeeId: $employeeId) {
          addImage {
            image {
              id
            }
            imageUploadUrl
            todo {
              images {
                id
              }
              ...TodoEditNewMainMediaComponentMedia_todo
            }
          }
        }
      }
    `
  );

  const { uploadImage, prepareForImageUpload } = useUploadImage();
  return useCallback(
    async (
      uri: string,
      { width, height }: { width: number; height: number }
    ) => {
      const uploadIdRequest = prepareForImageUpload({
        width,
        height,
        localImageURI: uri,
      });
      return addImageMutation({
        onCompleted: (data) => {
          uploadIdRequest.then((uploadId) => {
            if (data.todo?.addImage.imageUploadUrl) {
              uploadImage({
                imageId: data.todo.addImage.image.id,
                uploadURL: data.todo.addImage.imageUploadUrl,
                uploadId,
              });
            }
          });
        },
        variables: {
          todoId: id,
          employeeId: currentEmployeeId,
        },
      });
    },
    [
      prepareForImageUpload,
      addImageMutation,
      id,
      currentEmployeeId,
      uploadImage,
    ]
  );
}
